<template>
  <v-card class="elevation-0">
    <v-card-title primary-title>
      <span class="title">Fund Move</span>
    </v-card-title>
    <v-card-text class="pt-0">
      <v-slide-y-transition mode="out-in">
        <v-form v-model="valid" ref="form" @submit.prevent="submit" lazy-validation>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete
                  v-model="model.from"
                  label="From"
                  hide-selected
                  :items="moveAccounts"
                  item-text="key"
                  item-value="value"
                  :search-input.sync="fromSearch"
                  prepend-icon="mdi-account"
                  :rules="[v => !!v || 'This field is required']"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  v-model="model.to"
                  label="To"
                  hide-selected
                  :items="moveAccounts"
                  item-text="key"
                  item-value="value"
                  :search-input.sync="toSearch"
                  prepend-icon="mdi-account"
                  :rules="[v => !!v || 'This field is required']"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  v-model="model.currency"
                  label="Currency"
                  hide-selected
                  :items="formCurrencies"
                  item-text="key"
                  item-value="value"
                  item-disabled="disabled"
                  :search-input.sync="currencySearch"
                  prepend-icon="mdi-currency-btc"
                  :rules="[v => !!v || 'This field is required']"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.number="model.amount"
                  label="Amount"
                  type="number"
                  prepend-icon="mdi-currency-usd"
                  :rules="[
                  v => v > 0 || 'This field is required',
                  v => v <= this.currentAmount || `This field must be less than ${this.currentAmount}`
                  ]"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-btn color="primary" style="margin-left: 2.3em" type="submit" :loading="loading" :disabled="loading">Submit</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-slide-y-transition>
    </v-card-text>
  </v-card>
</template>

<script>
  import MongoService from '../../services/mongo.service'
  import MessageDialog from '../../libs/message-dialog/'
  // import { sortedUniq } from '../../libs/utils.js'

  export default {
    props: {
      accounts: { type: Array, required: false }
    },
    data () {
      return {
        loading: false,
        valid: true,
        model: {
          from: null,
          to: null,
          currency: null,
          amount: 0
        },
        fromSearch: null,
        toSearch: null,
        currencySearch: null,
        result: null
      }
    },
    computed: {
      accountList () {
        return this.accounts || []
      },
      moveAccounts () {
        return this.accountList.map(account => ({ 'key': account.account_name, 'value': account.account }))
      },
      formCurrencies () {
        if (!this.model.from || !this.model.to) return []
        const fromCurrencies = this.accountList.filter(account => account.account === this.model.from)[0].balances.map(balance => balance.currency)
        const toCurrencies = this.accountList.filter(account => account.account === this.model.to)[0].balances.map(balance => balance.currency)
        if (!fromCurrencies || !toCurrencies) return []
        const sameCurrencies = fromCurrencies.filter(currency => toCurrencies.indexOf(currency) >= 0)
        return sameCurrencies.map(currency => ({ 'key': currency, 'value': currency, 'disabled': sameCurrencies.indexOf(currency) === -1 }))
      },
      currentAmount () {
        if (!this.model.from || !this.model.to || !this.model.currency) return 0
        else {
          const fromBalances = this.accountList.filter(account => account.account === this.model.from)[0].balances
          const choosedCurrency = fromBalances.filter(balance => balance.currency === this.model.currency)[0].available
          return choosedCurrency
        }
      }
    },
    watch: {
      'model.from' (v) {
        if (v === this.model.to) {
          this.model.to = null
        }
      },
      'model.to' (v) {
        if (v === this.model.from) {
          this.model.from = null
        }
      }
    },
    methods: {
      async submit () {
        if (!this.$refs.form.validate()) return
        this.loading = true
        this.result = null
        const { from, to, currency, amount } = this.model
        try {
          const result = await MongoService.fund.internalBitstampFund({from, to, currency, amount})
          if (result) {
            MessageDialog.showSuccessMessage({
              html: `
                <div>Your request has been processed</div>
                <code class="mt-3 pl-3 pr-3 text-xs-left"><pre>${JSON.stringify({ from, to, currency, amount }, null, 2)}</pre></code>
              `
            })
          }
          this.result = result
        } catch (e) {
          MessageDialog.showErrorMessage({ text: e.toString() })
          console.error(e)
        }
        this.loading = false
      }
    }
  }
</script>
